<template>
    <div class="saved-panel">
        <div class="header">{{getSavePanelStatus()}}</div>
        <div class="body">
            <p class="type">
                <template>{{getSavePanelType()}}</template>
            </p>
            <div class="details d-flex justify-content-center">
                <p class="label">{{getSavePanelLabel()}}</p>
                <p class="info">{{getSavePanelInfo()}}</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'SavedPanel',
    props: {
        formData: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        getSavePanelStatus() {
            if (this.formData.status === 'draft') {
                return 'saved draft';
            }
            if (this.formData.status === 'submitted') {
                return 'submitted for review';
            }
            if (this.formData.status === 'ready') {
                return 'ready to oder';
            }

            return 'unsaved draft';
        },
        getSavePanelType() {
            let type = '';
            if (this.formData.use === 'general') {
                type = 'General Stock';
            } else {
                type = 'Patient Formulation';
            }
            if (this.formData.frequency === 'once') {
                type += ' - Once-off';
            } else {
                type += ' - Regular';
            }
            return type;
        },
        getSavePanelLabel() {
            return 'Author:';
        },
        getSavePanelInfo() {
            if (this.formData.created_by_user_id && this.formData.created_by_user_id !== this.$store.state.auth.user.userId
) {
                return this.formData.created_by_user_name;
            }
            return 'You';
        },
    },
};
</script>
